var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDbBatteryPerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H16",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99936 2H5.99936C3.79022 2 1.99936 3.79086 1.99936 6V18C1.99936 20.2091 3.79022 22 5.99936 22H7.99936",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0587 4.88889L16 4.88889C17.1046 4.88889 18 5.73457 18 6.77778V18.1111C18 19.1543 17.1046 20 16 20H8C6.89543 20 6 19.1543 6 18.1111L6 6.77778C6 5.73457 6.89543 4.88889 8 4.88889H10M14.0587 4.88889H10M14.0587 4.88889L14.0285 3.91673C14.0126 3.40614 13.5698 3 13.0289 3H11C10.4477 3 10 3.42284 10 3.94444V4.88889M8.94847 17.1667H15.0596C15.5817 17.1667 16.0048 16.743 16.004 16.2209V16.2209C16.0033 15.6998 15.5807 15.2778 15.0596 15.2778H8.94847C8.42635 15.2778 8.00329 15.7014 8.00403 16.2236V16.2236C8.00477 16.7446 8.4274 17.1667 8.94847 17.1667ZM8.9431 13.3889H15.0542C15.5763 13.3889 15.9994 12.9652 15.9987 12.4431V12.4431C15.9979 11.922 15.5753 11.5 15.0542 11.5H8.9431C8.42098 11.5 7.99792 11.9237 7.99866 12.4458V12.4458C7.9994 12.9669 8.42202 13.3889 8.9431 13.3889ZM8.93785 9.61111H15.049C15.571 9.61111 15.9941 9.18752 15.9934 8.66545V8.66545C15.9927 8.14432 15.5701 7.72222 15.049 7.72222L8.93785 7.72222C8.41577 7.72222 7.99273 8.14581 7.99341 8.66789V8.66789C7.99408 9.18901 8.41673 9.61111 8.93785 9.61111Z",
    stroke: "#101828",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbBatteryPerformance);
export default __webpack_public_path__ + "static/media/db-battery-performance.40938a188dcebdea61236b244699a71a.svg";
export { ForwardRef as ReactComponent };